import React from 'react';
import './styles.css';

const About = () => {
  return (
    <div className="dashboard-container">
      <div className="header-content">
        <h1 className="modern-title">About SteemBlocks</h1>
        <p className="modern-subtitle">Learn more about our mission, vision, and the team behind SteemBlocks</p>
      </div>

      <section className="about-section">
        <h2 className="section-title">Welcome to SteemBlocks</h2>
        <p className="section-text">
          A Steem dapp created by{' '}
          <a
            href="https://steemit.com/@dhaka.witness"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            @Dhaka.witness
          </a>{' '}
          team. We are committed to promoting transparency, decentralization, and community-driven governance on the
          Steem blockchain. As an elected witness, we are honored to serve the Steem community and contribute to the
          advancement of this remarkable platform.
        </p>
      </section>

      <section className="about-section">
        <h2 className="section-title">Basic Information</h2>
        <p className="section-text">
          <a
            href="https://steemit.com/@dhaka.witness"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            @Dhaka.witness
          </a>{' '}
          is a dedicated team of blockchain enthusiasts based in Dhaka, Bangladesh. With a deep understanding of the
          potential of blockchain technology, we have taken on the responsibility of running the following nodes:
        </p>
        <ul className="node-list">
          <li>Witness Node (<a href="https://steemit.com/@dhaka.witness" className="about-link"> @Dhaka.witness</a>)</li>
          <li>Seed Node 1 (seed.dhakawitness.com:2001)</li>
          <li>Seed Node 2 (seed2.dhakawitness.com:2001)</li>
          <li>WebSocket (<a href="https://dhakawitness.com/" target="_blank" rel="noopener noreferrer" className="about-link">https://dhakawitness.com/</a>)</li>
        </ul>

        <h3 className="subsection-title">DApps List:</h3>
        <ul className="dapps-list">
          <li>1. <a href="https://steemblocks.com/" target="_blank" rel="noopener noreferrer" className="about-link">SteemBlocks</a> - Comprehensive Steem blockchain explorer and analytics platform</li>
          <li>2. <a href="https://burn.steemblocks.com/" target="_blank" rel="noopener noreferrer" className="about-link">STEEM Burn Pool</a> - Community-driven STEEM token burning mechanism</li>
          <li>3. <a href="https://discord.com/oauth2/authorize?client_id=1276922336842612777" target="_blank" rel="noopener noreferrer" className="about-link">SteemStats</a> - Multifunctional Discord bot for real-time Steem blockchain statistics</li>
        </ul>

        <h3 className="subsection-title">Other Tools:</h3>
        <ul className="tools-list">
          <li>1. <a href="https://github.com/Steemblocks/Steem-MissedBlocks-Telegram-Bot" target="_blank" rel="noopener noreferrer" className="about-link">Telegram Witness Missed Blocks Alerts</a><br/>
              <span className="tool-description">Telegram bot for monitoring witness missed blocks and sending real-time alerts</span></li>
          <li>2. <a href="https://github.com/Steemblocks/Steem-Local-Broadcast" target="_blank" rel="noopener noreferrer" className="about-link">STEEM Local Broadcasting Tools</a><br/>
              <span className="tool-description">Local tools for broadcasting transactions to the Steem blockchain</span></li>
          <li>3. <a href="https://github.com/Steemblocks/Steem-Local-HTML-Js-Tool" target="_blank" rel="noopener noreferrer" className="about-link">STEEM Local HTML Js Tool</a><br/>
              <span className="tool-description">HTML/JavaScript utilities for local Steem blockchain interactions</span></li>
          <li>4. <a href="https://github.com/Steemblocks/Steem-WebSocket-Bridge" target="_blank" rel="noopener noreferrer" className="about-link">Steem WebSocket Bridge</a><br/>
              <span className="tool-description">WebSocket bridge for real-time Steem blockchain data streaming</span></li>
          <li>5. <a href="https://github.com/Steemblocks/Steem-WebSocket-Bridge-v2" target="_blank" rel="noopener noreferrer" className="about-link">Steem WebSocket Bridge v2</a><br/>
              <span className="tool-description">Enhanced version of the WebSocket bridge with improved features and performance</span></li>
        </ul>
      </section>

      <section className="about-section">
        <h2 className="section-title">Our Objective</h2>
        <p className="section-text">
          Our primary objective is to contribute to the growth and development of the Steem ecosystem through continuous
          innovation and user-centric services. We will gradually update and add new features on our SteemBlocks dapp.
        </p>
      </section>

      <section className="about-section">
        <h2 className="section-title">Our Mission</h2>
        <p className="section-text">
          Our mission at Dhaka.witness is to empower individuals and communities on the Steem blockchain. We envision a
          future where content creators, social media enthusiasts, and online communities thrive in a decentralized and
          transparent ecosystem. Through our witness operations, educational resources, and community engagement, we
          strive to foster an environment that encourages creativity, collaboration, and meaningful interactions.
        </p>
      </section>

      <section className="about-section">
        <h2 className="section-title">Our Vision</h2>
        <p className="section-text">
          We are committed to the core values of transparency, accountability, and open communication. We believe in
          regularly sharing updates, progress reports, and insights about our witness operations, development projects,
          and community initiatives. By embracing transparency, we aim to build trust within the Steem community and
          foster a stronger sense of collaboration and shared purpose.
        </p>
      </section>

      <section className="about-section">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-text">
          Join us on this exciting journey as we work together to shape the future of Steem. We welcome your
          support, engagement, and feedback. Connect with us on Discord ID:{' '}
          <a href="https://discord.com" className="about-link">
            steemblocks
          </a>
        </p>
      </section>

      <section className="about-section">
        <p className="section-text">
          Together, let us build a decentralized, transparent, and empowering platform that revolutionizes the way we
          create, share, and interact online.
        </p>
      </section>

      <section className="about-section closing-section">
        <p className="section-text">
          Thank you for being part of the Dhaka.witness community! <br /><br />
          <strong>Sincerely,</strong> <br />
          The{' '}
          <a
            href="https://steemit.com/@dhaka.witness"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            Dhaka witness
          </a>{' '}
          Team
          
          <div className="social-links">
            <a
              href="https://github.com/Steemblocks"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title="GitHub"
            >
              <svg viewBox="0 0 24 24" className="social-icon">
                <path fill="currentColor" d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <a
              href="https://steemit.com/@dhaka.witness/posts"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              title="Steemit"
            >
              <img 
                src="https://avatars.githubusercontent.com/u/17434692?s=280&v=4" 
                alt="Dhaka Witness" 
                className="social-avatar"
              />
            </a>
          </div>
        </p>
      </section>
    </div>
  );
};

export default About;
